'use strict';

import angular from 'angular';
import mobileNavigationMenuComponentModule from '../common/mobile_navigation_menu';

const mobileNavigationMenu = function ($window, $rootScope, $compile, scrollbarWidth, bodyScroll) {
  'ngInject';

  var bodyEl = angular.element($window.document.body);
  var wrapperEl = angular.element($window.document.querySelector('.Wrapper'));
  var menuEl;

  const service = {
    show: function () {
      if (menuEl) {
        return;
      }
      var scrollWidth = scrollbarWidth();
      menuEl = $compile('<sa-mobile-navigation-menu></sa-mobile-navigation-menu>')($rootScope.$new());
      wrapperEl.css('padding_right', scrollWidth + 'px');
      bodyEl.css('padding_right', scrollWidth + 'px');
      bodyScroll.disable();
      bodyEl.append(menuEl);
    },

    hide: function () {
      if (!menuEl) {
        return;
      }
      menuEl.remove();
      wrapperEl.css('padding_right', 0);
      bodyEl.css('padding_right', 0);
      bodyScroll.enable();

      menuEl = null;
    }
  };

  $rootScope.$on('breakpointChanged', function (event, breakpoint) {
    if (breakpoint !== 'mobile' && menuEl) {
      service.hide();
    }
  });

  return service;
};

const dependencies = [
  mobileNavigationMenuComponentModule
];

export default angular
  .module('services.mobileNavigationMenu', dependencies)
  .factory('mobileNavigationMenu', mobileNavigationMenu)
  .name;



// WEBPACK FOOTER //
// ./app/src/services/mobile_navigation_menu.service.js